/**实训任务模块 */
import request from '../request/http';
/**分页查询实训任务 */
export function PageQueryTask(data){
    return request({
        url: '/sp/trainingTask/pageQueryTask',
        method: 'post',
        data
    })
}
/**删除实训任务 */
export function RemoveTask(data){
    return request({
        url: '/sp/trainingTask/removeTask',
        method: 'post',
        data
    })
}
/**新增实训任务 */
export function SaveTask(data){
    return request({
        url: '/sp/trainingTask/saveTask',
        method: 'post',
        data
    })
}
/**修改实训任务 */
export function UpdateTask(data){
    return request({
        url: '/sp/trainingTask/updateTask',
        method: 'post',
        data
    })
}
/**根据任务id分页查询实训记录 */
export function PageQueryTrainingRecord(data){
    return request({
        url: '/sp/trainingTask/pageQueryTrainingRecord',
        method: 'post',
        data
    })
}
/**获取任务详情 */
export function GetTaskDetail(data){
    return request({
        url: '/sp/trainingTask/getTaskDetail',
        method: 'post',
        data
    })
}
/**个人中心-实训任务分页 */
export function StuPageQueryTask(data){
    return request({
        url: '/sp/trainingTask/stuPageQueryTask',
        method: 'post',
        data
    })
}
/**个人中心-分页查询实训得分详情 */
export function PageQueryTrainingScore(data){
    return request({
        url: '/sp/trainingTask/pageQueryTrainingScore',
        method: 'post',
        data
    })
}
/**分页查询用户实训详情 */
export function PageQueryUserTrainingRecord(data){
    return request({
        url: '/sp/trainingTask/pageQueryUserTrainingRecord',
        method: 'post',
        data
    })
}
